import { updateObject } from '../../shared/utility';
import { GET_ROLE_START, GET_ROLE_SUCCESS, GET_ROLE_FAIL } from '../actions/actionTypes';

const initialState={
    roles:[],
    error:null,
    loading:false,
}

const getRoleStart=(state,action)=>{
    return updateObject(state,{error:null,loading:true});
}

const getRoleSuccess=(state,action)=>{
    return updateObject(state,{roles:action.roles,error:null,loading:false});
}

const getRoleFail=(state,action)=>{
    return updateObject(state,{error:action.error,loading:false});
}

const roleReducer=(state=initialState,action)=>{
    switch (action.type) {
        case GET_ROLE_START:
            return getRoleStart(state,action);
        case GET_ROLE_SUCCESS:
            return getRoleSuccess(state,action);
        case GET_ROLE_FAIL:
            return getRoleFail(state,action);
        default:
            return state;
    }
}

export default roleReducer;